import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Ensure React is available globally
window.React = React;

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');

const root = ReactDOM.createRoot(container);

// Wrap the render in a try-catch to catch any initialization errors
try {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  console.error('Failed to render React application:', error);
  // Display a user-friendly error message
  const errorDiv = document.createElement('div');
  errorDiv.style.cssText = 'padding: 20px; color: red; text-align: center;';
  errorDiv.textContent = 'Failed to initialize the application. Please try refreshing the page.';
  container.appendChild(errorDiv);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
